import React, { useContext } from 'react';

import './index.scss';

import LodingImage from 'assets/loading.svg';
import { PAGE_MAP, FATAL_ERROR_MESSAGES } from 'utils/constant';
import {
  useAnalytics,
} from 'utils';
import AppContext from 'fluxes/context';
import PcHeader from 'components/organisms/PcHeader';
import PcFooter from 'components/organisms/PcFooter';

// PC用のテンプレート
const PcBasicTemplate = ({ 
  path,
  children,
  onClickMainButton,
  valid,
  isApiError,
  showLoading,
}) => {
  const { state } = useContext(AppContext);
  const { title, prevUrl, nextUrl, buttonType } = PAGE_MAP[path];
  
  useAnalytics(); // Web計測
  
  return (
    <div className='PcBasicTemplate'>
      <div className="header">
        <PcHeader 
          title={title}
          state={state}
          path={path}
        />
      </div>
      <div className="center">
        <div className="wrapper">
          <div className="main">
            <div className="children">
              {children}
            </div>
          </div>
        </div>
      </div>
      <div className="footer-wrapper">
        <div className="footer">
          <PcFooter 
            onClickMainButton={onClickMainButton}
            prevUrl={prevUrl}
            nextUrl={nextUrl}
            buttonType={buttonType}
            valid={valid}
          />
        </div>
      </div>
      {/* ローディング */}
      {showLoading && (
        <div className="loading-modal-wrapper">
          <div className="loading-modal-wrapper-background">
            <img className="loading-image" src={LodingImage} alt="loading" />
          </div>
        </div>
      )} 
      {/* APIエラーモーダル */}
      {isApiError && (
        <div className="api-error-modal-wrapper">
          <div className="api-error-modal-wrapper-background">
            <div className="api-error-modal">
              {FATAL_ERROR_MESSAGES.map(message => <div key={message}>{message}</div>)}
              <div className="api-error-top-link"><a href="/clcd/odform/">TOPへ戻る</a></div>
            </div>
          </div>
        </div>
      )} 
    </div>
  );
};

export default PcBasicTemplate;